import * as React from "react"

import { Labels } from "../../../../../util/Translations"

interface Props {
    attributes: Record<string, string>
    isLoading?: boolean
    label?: string
}

export const UnavailableLink = ({
    attributes,
    isLoading,
    label,
}: Props): JSX.Element => {
    const { LinkUnavailable } = Labels

    return (
        <span {...attributes}>
            {label}
            {!isLoading && <> ({LinkUnavailable})</>}
        </span>
    )
}

export default UnavailableLink
